import store from '@/store/store';

import dashboard from './dashboard';
import analysis from './analysis';
import profile from './profile';
import sendReferral from './send-referral';
import viewReferrals from './view-referrals';
import viewReferral from './view-referral';
import editReferral from './edit-referral';
import viewMembers from './view-members';
import viewMember from './view-member';
import memberReports from './member-reports';
import viewLeaderboard from './view-leaderboard';

export default {
  path: 'app',
  component: () => import('@/layouts/main/Main.vue'),
  children: [
    dashboard,
    analysis,
    profile,
    sendReferral,
    viewReferrals,
    viewReferral,
    editReferral,
    viewMembers,
    viewMember,
    memberReports,
    viewLeaderboard
  ],
  beforeEnter: async (to, from, next) => {
    const privateRoot = await store.state.router.apiRoot.$request().$get('private');
    store.commit('router/updateRouteProp', {
      property: 'privateRoot',
      value: privateRoot
    });
    const profileResource = await privateRoot.$request().$get('profile');
    store.commit('router/updateRouteProp', {
      property: 'profileResource',
      value: profileResource
    });
    next();
  }
};
